class BebeomiMenuDrawer extends HTMLElement {
  connectedCallback() {
    this.openButton = this.querySelector('[data-b-drawer-open]');
    this.panel = this.querySelector('.b-drawer__panel');
    this.closeButtons = this.querySelectorAll('[data-b-drawer-close]');

    this.openButton?.addEventListener('click', () => this.open());
    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    this.addEventListener('click', (event) => {
      if (event.target.closest?.('a[href]')) this.close();
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
    });
  }

  open() {
    this.setAttribute('open', '');
    this.openButton?.setAttribute('aria-expanded', 'true');
    this.panel?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    if (this.panel && typeof trapFocus === 'function') trapFocus(this.panel, this.panel.querySelector('[data-b-drawer-close]'));
  }

  close() {
    this.removeAttribute('open');
    this.openButton?.setAttribute('aria-expanded', 'false');
    this.panel?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.openButton);
  }
}

if (!customElements.get('bebeomi-menu-drawer')) {
  customElements.define('bebeomi-menu-drawer', BebeomiMenuDrawer);
}

class BebeomiHeader extends HTMLElement {
  connectedCallback() {
    this.megaMenus = this.querySelectorAll('[data-b-mega]');
    this.megaMenus.forEach((menu) => {
      const trigger = menu.querySelector('[data-b-mega-trigger]');

      const openMenu = () => {
        this.closeMegaMenus();
        menu.classList.add('is-open');
        trigger?.setAttribute('aria-expanded', 'true');
      };

      menu.addEventListener('pointerenter', openMenu);
      trigger?.addEventListener('focus', openMenu);
      menu.addEventListener('pointerleave', () => {
        window.setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) {
            menu.classList.remove('is-open');
            trigger?.setAttribute('aria-expanded', 'false');
          }
        }, 120);
      });
      menu.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!menu.contains(document.activeElement) && !menu.matches(':hover')) {
            menu.classList.remove('is-open');
            trigger?.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });

    this.addEventListener('click', (event) => {
      if (event.target.closest?.('a[href]')) this.closeMegaMenus();
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.closeMegaMenus();
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeMegaMenus(true);
    });
    this.schedulePositionUpdate = () => {
      if (this.positionUpdateFrame) return;
      this.positionUpdateFrame = window.requestAnimationFrame(() => {
        this.positionUpdateFrame = null;
        this.updateMobileSearchPosition();
      });
    };

    this.querySelector('.b-search__input')?.addEventListener('focus', this.schedulePositionUpdate);
    this.updateMobileSearchPosition();
    window.addEventListener('resize', this.schedulePositionUpdate, { passive: true });
    window.addEventListener('scroll', this.schedulePositionUpdate, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.schedulePositionUpdate);
    window.removeEventListener('scroll', this.schedulePositionUpdate);
    if (this.positionUpdateFrame) window.cancelAnimationFrame(this.positionUpdateFrame);
  }

  closeMegaMenus(returnFocus = false) {
    this.megaMenus.forEach((menu) => {
      const trigger = menu.querySelector('[data-b-mega-trigger]');
      menu.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger?.focus();
    });
  }

  updateMobileSearchPosition() {
    const stickySection = this.closest('.bebeomi-header-section');
    const headerBounds = (stickySection || this).getBoundingClientRect();
    const bottom = Math.max(headerBounds.bottom, 0);
    this.style.setProperty('--b-header-bottom', `${bottom}px`);
    this.style.setProperty('--b-mobile-results-top', `${bottom}px`);
    document.documentElement.style.setProperty('--bebeomi-sticky-header-height', `${headerBounds.height}px`);
  }
}

if (!customElements.get('bebeomi-header')) {
  customElements.define('bebeomi-header', BebeomiHeader);
}
